module.exports = __webpack_public_path__ + "img/live_xg.dc1eecf2.png";